import {
  AfterContentInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  forwardRef,
  Input,
  Renderer2
} from '@angular/core';
import { BASE_LAYOUT, WizBaseLayout } from '../../core/wiz-base-layout';

/**
 * Groupe affichant ses enfants en alignement horizontal
 */
@Component({
  selector: 'wizhgroup2',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./wiz-hgroup.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: BASE_LAYOUT, useExisting: forwardRef(() => WizHgroup2)},
    {provide: WizBaseLayout, useExisting: forwardRef(() => WizHgroup2)},
  ]
})
export class WizHgroup2 extends WizBaseLayout implements AfterContentInit, DoCheck {

  constructor(elementRef: ElementRef, renderer: Renderer2, protected cdref: ChangeDetectorRef) {
    super(elementRef, renderer, cdref);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();

    this.ngDoCheck();
  }

  /*
   * Détection de l'injection de composants enfants
   */
  ngDoCheck(): void {
    // Check si le nombre d'enfants a changé
    if (this.children && this.children.length !== this.numChildren) {
      this.numChildren = this.children.length;
      this.applyGap();
    }
  }

  /**
   * Application de l'espace entre les enfants en appliquant des marges css
   */
  applyGap() {
    super.applyGap();
    // Conversion du gap en css
    for (const element of this.children) {
      if (this.numChildren === 1) {
        this.renderer.setStyle(element, 'margin', '0px ');
      } else if (element === this.children[0]) {
        this.renderer.setStyle(element, 'margin-right', this.gap / 2 + 'px');
      } else if (element === this.children[(this.children.length - 1)]) {
        this.renderer.setStyle(element, 'margin-left', this.gap / 2 + 'px');
      } else {
        this.renderer.setStyle(element, 'margin-right', this.gap / 2 + 'px');
        this.renderer.setStyle(element, 'margin-left', this.gap / 2 + 'px');
      }
    }
  }

  /**
   * Application de l'alignement horizontal par application du style 'justify-content'
   * @param horizontalAlign 'start', 'center', 'end' ou 'space-between'
   */
  @Input() set horizontalAlign(horizontalAlign: 'start' | 'center' | 'end' | 'space-between') {
    this._horizontalAlign = horizontalAlign;

    if (horizontalAlign === 'end') {
      // Les éléments flexibles sont regroupés à la fin
      this.renderer.setStyle(this.elementRef.nativeElement, 'justify-content', 'flex-' + horizontalAlign);
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'justify-content', horizontalAlign);
    }
    this.cdref.markForCheck();
  }

  /**
   * Application de l'alignement vertical par application du style 'align-items'
   * @param verticalAlign 'start', 'center', 'end', 'flex-start', 'flex-end' ou 'space-between'
   */
  @Input() set verticalAlign(verticalAlign: 'start' | 'center' | 'end' | 'flex-start' | 'flex-end' | 'space-between') {
    this._verticalAlign = verticalAlign;
    if (['center', 'space-between'].indexOf(verticalAlign) === -1) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'align-items', 'flex-' + verticalAlign);
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'align-items', verticalAlign);
    }
    this.cdref.markForCheck();
  }

}
